export default __webpack_public_path__ + "static/media/race-icon-cutted.129974d5.png";